// The server's limits (better-auth defaults). Checked here too, to save a round trip.
const MIN_PASSWORD_LENGTH = 8;
const MAX_PASSWORD_LENGTH = 128;

const TOO_SHORT = "Use at least 8 characters.";
const TOO_LONG = "Use 128 characters or fewer.";
const NO_MATCH = "The passwords don't match.";

/** What is wrong with a new password typed twice, or null when it can be sent. */
export function checkNewPassword(
  password: string,
  repeat: string,
): string | null {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return TOO_SHORT;
  }
  if (password.length > MAX_PASSWORD_LENGTH) {
    return TOO_LONG;
  }
  if (password !== repeat) {
    return NO_MATCH;
  }
  return null;
}

/** What the repeat box's match icon shows. "none" keeps its slot empty. */
export type PasswordMatch = "none" | "match" | "mismatch";

/** A ✗ waits until the repeat is as long as the password, or the user left
 *  the box, so it doesn't flash on every keystroke. */
export function passwordMatch(
  password: string,
  repeat: string,
  hasLeftRepeat: boolean,
): PasswordMatch {
  if (!repeat) {
    return "none";
  }
  if (repeat === password) {
    return "match";
  }
  if (hasLeftRepeat || repeat.length >= password.length) {
    return "mismatch";
  }
  return "none";
}

/** The message for the server's refusal of the password itself, or null for any other error. */
export function describePasswordRefusal(
  code: string | undefined,
): string | null {
  if (code === "PASSWORD_TOO_SHORT") {
    return TOO_SHORT;
  }
  if (code === "PASSWORD_TOO_LONG") {
    return TOO_LONG;
  }
  return null;
}
